// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__1yVoJ","Label":"Checkbox_Label__1Bnsq","InputElement":"Checkbox_InputElement__1tXPq","Invalid":"Checkbox_Invalid__3c6E4"};